<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>



        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3 property-image">
            <p-image src="{{url}}" alt="{{caption}}" width="400"></p-image>
            <p-fileUpload mode="basic" [auto]="true" name="files" [url]="getUploadUrl()" (onUpload)="onAfterUpload($event)" (onBeforeUpload)="onBeforeUpload($event)"
            accept=".jpg,.jpeg,.gif" maxFileSize="52428800" class="fileUpload"></p-fileUpload>
            @if (isLoader) {
              <div><p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner></div>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="title" id="title" type="text" pInputText>
            <label for="title">Title</label>
            @for (validation of validationMessages.title; track validation) {
              <span>
                @if (form1.get('title').hasError(validation.type) && (form1.get('title').dirty || form1.get('title').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="caption" id="caption" [rows]="3" pInputTextarea></textarea>
            <label for="caption">Caption</label>
            @for (validation of validationMessages.caption; track validation) {
              <span>
                @if (form1.get('caption').hasError(validation.type) && (form1.get('caption').dirty || form1.get('caption').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="slPictureId" id="slPictureId" type="text" pInputText>
            <label for="slPictureId">SL Picture ID</label>
            @for (validation of validationMessages.slPictureId; track validation) {
              <span>
                @if (form1.get('slPictureId').hasError(validation.type) && (form1.get('slPictureId').dirty || form1.get('slPictureId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (pictureId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete Picture</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!pictureId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add Picture</button>
              }

              @if (pictureId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Picture</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>